import type { RouteRecordRaw } from 'vue-router'
import { getOldByocRoutes } from '@/routes/user/services/byoc'
import {
  getFormsDetailsRoutes,
  getFormsRoutes,
  getAutomationRulesRoutes,
  getCarrierLookupRoutes,
  getEmailLookupRoutes,
  getApiRoutes,
  getPointAIRoutes,
  getEmailToSmsRoutes,
  getSmsSurveysRoutes,
  getOldSenderSettingsRoutes,
} from '@/routes/user/services/oldServicesRoutes'

export const getServicesRoutes = (): RouteRecordRaw[] => [
  {
    name: 'user.services',
    path: 'services',
    redirect: { name: 'user.services.senderSettings.numbers' },
    children: [
      ...getOldByocRoutes(),
      ...getOldSenderSettingsRoutes(),
      ...getCarrierLookupRoutes(),
      ...getEmailLookupRoutes(),
      ...getFormsRoutes(),
      ...getFormsDetailsRoutes(),
      ...getAutomationRulesRoutes(),
      ...getApiRoutes(),
      ...getPointAIRoutes(),
      ...getEmailToSmsRoutes(),
      ...getSmsSurveysRoutes(),
    ],
  },
]
